<template>
    <div :class="{
        'empty-state-into-card': $route.name === 'campaigns',
        'has-trial-alert': hasTrialAlert}">
        <Icon :icon="icon"/>
        <p>{{ text }}</p>
    </div>
</template>

<script>
import Icon from '@/components/Theme/Icon'
import { computed, onMounted, ref } from '@vue/composition-api'
import {useStore} from '../../../../core/hooks'
export default {
    name: 'EmpatyStateCampaigns',
    components: {
        Icon
    },
    props: {
        stateIcon: String
    },
    setup: function(props) {
        let icon = ref()
        let text = ref()

        const {store} = useStore()
        const hasTrialAlert = computed(() => store.getters.hasTrial && !store.getters.membershipStatus)

        onMounted(() => {
            if(props.stateIcon === 'publish') {
                icon.value = 'publish-empty-state'
                text.value = 'Verified campaigns will show here after you add them'
                return icon
            }
            if(props.stateIcon === 'archives') {
                icon.value = 'archive-empty-state' 
                text.value = "You can archive published campaigns that you're not going to use anymore"
                return icon
            }
            if(props.stateIcon === 'drafts') {
                icon.value = 'publish-empty-state'
                text.value = 'Campaigns that are not yet verified will show here'
                return icon
            }
            if(props.stateIcon === 'favorite') {
                icon.value = 'favorite-empty-state'
                text.value = 'Campaigns that you marked as favorite will appear here'
                return icon
            }
        })
        return {
            icon,
            text,
            hasTrialAlert
        }
    }
}
</script>
<style scoped lang="scss">
@import  '../../../../assets/scss/variables.scss';
div.empty-state-into-card {
    width: 100%;
    min-height: calc(100vh - 165px); 
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    &.has-trial-alert {
        min-height: calc(100vh - 225px); 
    }

    p {
        color: $c3;
        font-size: $p3;
        margin-top: 16px;
    }
}
</style>
